import { render, staticRenderFns } from "./Localization.vue?vue&type=template&id=bf683a12&scoped=true&"
import script from "./Localization.vue?vue&type=script&lang=js&"
export * from "./Localization.vue?vue&type=script&lang=js&"
import style0 from "./Localization.vue?vue&type=style&index=0&id=bf683a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf683a12",
  null
  
)

export default component.exports